import { APIKey, listApiKeys } from '../../../../../../services/apiKey'

export function useFetchApiKeys() {
  return async function fetchApiKeys(personId: string): Promise<APIKey[]> {
    const apiKeys = await listApiKeys(personId)
    return apiKeys
  }
}
